export default "__VITE_ASSET__DyKcSjko__"